import { Stack } from '@mui/material'
import { getCodeSetLabelLookup } from '../Functions/CodeSetFns'
import { useUserContext } from '../Contexts/UserConfig'
import PageSection from '../Constants&Theme/PageSection'
import { useGetScreenCollection } from '../APIs/Hooks/ScreenCollectionHooks'
import { tsGetSampleRun } from '../Typescript/API_Response'
import { ReadOnlyTextField } from '../garvan-react/Components/ReadOnlyTextField'
import { stackGap } from '../Constants&Theme/Spacing'

function RelatedScreen({
  sampleRun,
}: {
  sampleRun: tsGetSampleRun | undefined
}) {
  const { loginConfig } = useUserContext()
  const { data: collection, isLoading } = useGetScreenCollection(
    sampleRun?.runInfo?.ScreenCollectionID,
  )

  return (
    <PageSection
      title={'Related Screening Information'}
      loading={isLoading}
    >
      <Stack
        width={1}
        gap={stackGap.row}
        direction={'row'}
      >
        <Stack
          width={1}
          flex={1}
          gap={stackGap.col}
        >
          <ReadOnlyTextField
            label="Criteria"
            fullWidth
            value={
              getCodeSetLabelLookup(
                loginConfig,
                ['ScreenCriteriaID'],
                collection?.Collection?.Criteria,
              ) || ''
            }
          />
          <ReadOnlyTextField
            fullWidth
            label="Criteria Details"
            value={collection?.Collection?.CriteriaDetails || ''}
          />
        </Stack>
        <Stack
          flex={2.5}
          width={1}
          gap={stackGap.col}
        >
          <ReadOnlyTextField
            fullWidth
            label="Tests"
            value={collection?.Collection?.Tests || ''}
          />
          <ReadOnlyTextField
            fullWidth
            label="Collection Instructions"
            value={collection?.Collection?.CollectionInstructions || ''}
          />
        </Stack>
      </Stack>
    </PageSection>
  )
}

export default RelatedScreen
